/* eslint-disable */
import getBatchLabelXml from "./myBatchLabel"
import getMaterialLabelXml from "./myMaterialLabel"
require("./dymoLibrary");

export default class Dymo {
  constructor(options) {
    options = options || {};
    if (options.material) {
      this.myLabel = getMaterialLabelXml();
    } else {
      this.myLabel = getBatchLabelXml();
    }
    this.myParams = dymo.label.framework.createLabelRenderParamsXml(
      {
        pngUseDisplayResolution: false,
        shadowDepth: "10",
        labelColor: {
          r: 251,
          g: 251,
          b: 251
        }
      }
    );
  }


  // use this to get an array fo useable printer names
  getAvailablePrinters () {
    // get array of printers
    let printers = dymo.label.framework.getPrinters();
    if (printers.length === 0) {
      console.log("No Dymos are installed")
    } else {
      let printerArray = []
      for (let i = 0; i < printers.length; i++) {
         let printer = printers[i];
         if (printer.printerType === "LabelWriterPrinter") {
             printerArray.push(printer.name);
         }
      }
      return printerArray
    }
  }
  setBatch(obj) {
    return this.myLabel.setObjectText("BATCH", `BATCH: ` + String(obj.batchID))
  }
  setRun(obj) {
    return this.myLabel.setObjectText("RUN", `RUN: ` + String(obj.run))
  }
  setWeight(obj) {
    return this.myLabel.setObjectText("WEIGHT", `WEIGHT: ` + String(obj.weight))
  }
  setMaterial(obj) {
    return this.myLabel.setObjectText("MATERIAL", `MATERIAL: ` + String(obj.material))
  }
  setLot(obj) {
    return this.myLabel.setObjectText("LOT", `LOT: ` + String(obj.lot))
  }
  setCode(obj) {
    return this.myLabel.setObjectText("CODE", `BARCODE: ` + String(obj.barcode))
  }
  printLabel(printer) {
    this.myLabel.print(printer)
  }

  // Check Variable Names
  getName() {
    return this.myLabel.getObjectNames()
  }

  // Get Image render of label
  getRender() {
    return "data:image/png;base64," + this.myLabel.render(this.myParams, "DYMO LabelWriter 450 Turbo")
  }
}

if (typeof module !== 'undefined' && module.exports) {
	module.exports = Dymo;
} else {
	window.Dymo = Dymo;
}